import loaderSlice from './loaderSlice';

export const loaderReducer = loaderSlice.reducer;
export const loaderActions = loaderSlice.actions;
